import formatDateWithTimezone from "@insite/client-framework/Common/Utilities/formatDateWithTimezone";

import { ApiHandlerDiscreteParameter, HasOnError, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { Cart, CartResult, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";

import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";

const convertDateToApiFormat = (date: Date | null) => (date ? formatDateWithTimezone(date) : "");

interface PlaceOrderParameter {
    paymentMethod: string;
    poNumber: string;
    vatNumber?: string;
    saveCard: boolean;
    cardHolderName: string;
    cardNumber: string;
    cardType: string;
    expirationMonth: number;
    expirationYear: number;
    securityCode: string;
    useBillingAddress: boolean;
    address1: string;
    countryId: string;
    stateId: string;
    city: string;
    postalCode: string;
    onSuccess?: (cartId: string) => void;
    payPalToken?: string;
    payPalPayerId?: string;
    isPending?: boolean;
    isAdyenDropIn?: boolean;
    adyenPspReference?: string;
    accountHolderName?: string;
    accountNumber?: string;
    routingNumber?: string;
    properties?: { customerCollectAccountNumber?: string };
}

type HandlerType = ApiHandlerDiscreteParameter<
    PlaceOrderParameter & HasOnError,
    UpdateCartApiParameter,
    CartResult,
    {
        cartToUpdate: Cart;
        properties?: { customerCollectAccountNumber?: string };
    }
>;

export const PopulateApiParameterExtended: HandlerType = props => {
    if (!props.cartToUpdate) {
        return;
    }

    const {
        pages: {
            checkoutReviewAndSubmit: { requestedDeliveryDate, requestedPickupDate },
        },
    } = props.getState();
    const tempDeliveryDate =
        typeof requestedDeliveryDate !== "undefined"
            ? requestedDeliveryDate
            : props.cartToUpdate.requestedDeliveryDateDisplay;
    const tempPickupDate =
        typeof requestedPickupDate !== "undefined"
            ? requestedPickupDate
            : props.cartToUpdate.requestedPickupDateDisplay;

    if (props.parameter.properties?.customerCollectAccountNumber) {
        props.apiParameter = {
            cart: {
                ...props.cartToUpdate,
                requestedDeliveryDate: convertDateToApiFormat(tempDeliveryDate),
                requestedPickupDate: convertDateToApiFormat(tempPickupDate),
                properties: { customerCollectAccountNumber: props.parameter.properties?.customerCollectAccountNumber },
            },
        };
    } else {
        props.apiParameter = {
            cart: {
                ...props.cartToUpdate,
                requestedDeliveryDate: convertDateToApiFormat(tempDeliveryDate),
                requestedPickupDate: convertDateToApiFormat(tempPickupDate),
            },
        };
    }
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterExtended);
